import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AssignmentForm from "./FormSection";

import { getVendorPaymentRequestList , getListFilterData, approveHoldRequest} from "services/redux/sales/vendorPortal/action";
import {getReportee, search, newAssignee} from "../../../services/redux/BulkAssignment/action";

const mapStateToProps = (state) => ({
    cities: state.locationReducer.cities,
    zones: state.locationReducer.zones,
    areas: state.locationReducer.areas,
    siteTypes: state.fileComplainReducer.siteTypes,
    siteInfo: state.fileComplainReducer.siteInfo,
    reportee: state.bulkAssignmentReducer.reportee,
    searchInfo: state.bulkAssignmentReducer.searchInfo,
    newAssigneeRes: state.bulkAssignmentReducer.newAssigneeRes,
    dataList: state.vendorPortalReducer.payment_request_list,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getReportee,
        search,
        newAssignee,
        getVendorPaymentRequestList,
        approveHoldRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentForm);
